import React from "react";
import PropTypes from "prop-types";
import { FluentCalendarDrilldown } from "../../../FluentUI/Fluent-Calendar-Drilldown";

import "./table-datepicker.scss";

const TableDatePicker = ({ selectedDate, setSelectedDate, onChange }) => {
  const handleSelect = (date) => {
    setSelectedDate?.(date);
    onChange?.(date);
  };

  return (
    <div className="table-datepicker-wrapper">
      <FluentCalendarDrilldown
        value={selectedDate ?? undefined}
        onSelectDate={handleSelect}
        isMonthPickerVisible
        showMonthPickerAsOverlay
      />
    </div>
  );
};

TableDatePicker.propTypes = {
  selectedDate: PropTypes.instanceOf(Date),
  setSelectedDate: PropTypes.func,
  onChange: PropTypes.func,
};

export default TableDatePicker;
